export function HasPermission(permission) {
  const permissions = localStorage.getItem("@App:permissions");

  return permissions?.includes(permission);
}
